<div class="user-menu-wrapper">
    <div id="businessProfileButton" (click)="presentBusinessProfile($event)" class="shortname">{{ user?.NombreOrganizacion | shortName }}</div>
    <div class="vertical-divider"></div>
    <div class="user-menu-actions-wrapper" (click)="presentPersonalProfile($event)">
        <div class="shortname">{{ user?.NombreUsuario | shortName }}</div>
        <div class="user-menu">
            <div class="body-small">{{ user?.NombreUsuario }}</div>
            <div class="body-x-small">{{ user?.NombreRol }}</div>
        </div>
    </div>
</div>